import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { registerServiceWorker } from "./lib/register-sw";
import "./styles/tokens.css";
import "./styles/global.css";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("SecOps Guard: #root element not found in index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Installable PWA + offline app shell. Prod-only, feature-detected, never throws —
// pure progressive enhancement (see src/lib/register-sw.ts).
registerServiceWorker();
